export default __webpack_public_path__ + "static/media/11(KEARI-CRESCENT).efe65fc9.jpg";